/*=========================================================================================
    File Name: apexChartData.vue
    Description: Data shown by charts
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

function generateData(baseval, count, yrange) {
  let i = 0;
  const series = [];
  while (i < count) {
    //var x =Math.floor(Math.random() * (750 - 1 + 1)) + 1;;
    const y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
    const z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;

    series.push([baseval, y, z]);
    baseval += 86400000;
    i++;
  }
  return series;
}

function generateDataHeatMap(count, yrange) {
  let i = 0;
  const series = [];
  while (i < count) {
    const x = `w${(i + 1).toString()}`;
    const y =
      Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;

    series.push({
      x,
      y
    });
    i++;
  }
  return series;
}

const themeColors = ["#6a5544", "#28C76F", "#EA5455", "#FF9F43", "#1E1E1E"];

export default {
  lineChartSimpleWeight: {
    series: [
      { name: "ريما فرنسيس", data: [104.9, 103.8, 102, 101.6] },
      { name: "منى جابر", data: [58.5, 56.3, 55.3] },
      { name: "امل فلوس", data: [90.9, 90, 89] },
      { name: "أميرة محمد مصري", data: [86.7, 86, 85.5, 84.3, 83.2] },
      {
        name: "دعاء زريقات",
        data: [135, 133, 132.7, 132.4, 132.1, 131, 130.5, 130]
      },
      { name: "Manar Saada", data: [70.7, 70, 69.3, 68.7] },
      {
        name: "امال اون لاين",
        data: [67.7, 67.2, 65.5, 66, 65, 65, 65, 64, 67]
      },
      { name: "امل تيتي", data: [90] },
      {
        name: "eiman amoor",
        data: [55.5, 54.5, 54, 54.4, 54.6, 54.6, 54.8, 53.9]
      },
      { name: "لينا شداد", data: [97] },
      { name: "رشا محمد محمد ايوب", data: [84.3, 84, 84] },
      { name: "شيرين قدح", data: [66.9, 65.2, 64.4, 63.3] },
      { name: "اسماء محمد", data: [73.8, 72, 71, 72] },
      { name: "Maisoon Bsoul", data: [81.9, 80.2, 78, 77.8] },
      {
        name: "Musab Abdel Hafez",
        data: [106, 103.6, 101, 101.4, 99.9, 98.4, 97.9, 97.4, 96.6, 95.4, 94.2]
      },
      { name: "الاء محمد قنعير", data: [112, 111, 110] },
      { name: "سهير خوري", data: [80.6, 79.6, 78.2, 77, 77, 75.6, 75, 75, 75] },
      { name: "نزهه صالح", data: [68.6, 67.7, 66.8] },
      { name: "نور صالح", data: [61.1, 60.9, 59] },
      { name: "اصالة مصطفى نصار", data: [60.7, 59] },
      { name: "زينب خالد مصاروة", data: [76, 75.5, 75, 73.2, 72] },
      { name: "ضحى علي قبند", data: [72.6, 71.6, 70.5, 70, 69.9, 69.3] },
      { name: "دعاء جبارين", data: [74, 73, 72, 71, 70, 69.3, 69.1, 69] },
      { name: "سهى ابو الهيجاء", data: [73.5, 72.3, 72, 71.4, 71] },
      { name: "سما يعيش", data: [69, 70, 69, 68.4, 67.9] },
      { name: "رشا نبراوي", data: [70, 70, 71, 70.5, 69.7] },
      {
        name: "غزاله ابو صيام",
        data: [
          78,
          76.4,
          76,
          74.7,
          74,
          73.9,
          72,
          71.8,
          71,
          70.8,
          70,
          69.7,
          69.4,
          68.9
        ]
      },
      { name: "مسك رسمي بيادسة", data: [70, 69.5, 69, 68] },
      {
        name: "ايه حاج يحيى",
        data: [
          110.7,
          110,
          109,
          109,
          108.5,
          108.1,
          107.8,
          107,
          107,
          106.2,
          106,
          105,
          104.5,
          104
        ]
      },
      {
        name: "rasha telhami",
        data: [62, 61.5, 61, 60.5, 59.6, 62, 61.7, 61.4, 61.1, 60.4]
      },
      {
        name: "حنان ابومخ",
        data: [81.7, 79.6, 79.8, 79.5, 79, 79, 78.5, 78, 77, 77.5, 75.5]
      },
      {
        name: "ريم رفاعي",
        data: [
          100,
          99,
          98,
          97,
          97,
          95.2,
          93.2,
          92.9,
          92.5,
          91.2,
          91.2,
          89.7,
          90,
          89.7
        ]
      },
      { name: "منى خازم", data: [65, 64, 63.3, 64] },
      {
        name: "مريم سلامه",
        data: [
          87.5,
          87,
          86.3,
          85.5,
          85.1,
          84.9,
          84.5,
          84,
          83.5,
          83,
          82.8,
          82.3,
          82.1,
          81.8
        ]
      },
      {
        name: "اماني احمد سليمان",
        data: [73.9, 71, 72, 71, 69, 68, 67.3, 67, 67, 66, 66.5]
      },
      {
        name: "رنين لحام",
        data: [54.4, 53.7, 53, 53, 52.8, 52.6, 52, 52, 52.4, 52.2, 51.8, 51.8]
      },
      {
        name: "ياسمين وتد",
        data: [
          54,
          52.5,
          51.5,
          51.5,
          53,
          52.4,
          52.2,
          51.2,
          51.1,
          51,
          51,
          50.5,
          51
        ]
      },
      {
        name: "فاطمه عكاوي",
        data: [82, 81.5, 81, 81, 79, 78, 77.1, 76.5, 75, 74]
      },
      {
        name: "نورا شهوان",
        data: [106, 104.5, 102.5, 102, 101, 100, 99.5, 98, 98]
      },
      {
        name: "فاتن= دراوشة",
        data: [
          102,
          103.6,
          102,
          101,
          100.5,
          100,
          99,
          99.5,
          99,
          98.5,
          98.3,
          98,
          97.8
        ]
      },
      {
        name: "نهاية عطية",
        data: [81.3, 81, 80.5, 80, 79.7, 79, 79, 79, 79, 79, 79, 79]
      },
      { name: "لورين شريف", data: [108, 106.8] },
      {
        name: "منار مراعنة",
        data: [78.1, 75.4, 76, 75.3, 75, 74.3, 74, 73.3, 74, 73]
      },
      {
        name: "شفاء مرعي",
        data: [
          75.5,
          74.1,
          73.1,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7,
          75.7
        ]
      },
      {
        name: "مرام عبد الهادي",
        data: [
          74.5,
          74.5,
          73.9,
          75,
          74.4,
          73.8,
          73,
          74,
          75.2,
          75,
          74.8,
          74.4,
          73,
          72.6
        ]
      },
      { name: "ختام الحاج", data: [88.4, 88, 87.5, 87, 77] },
      {
        name: "عدن بلبل",
        data: [67, 67.5, 68, 67, 67.4, 66.3, 64.4, 64, 63.4, 63, 64, 63, 63, 62]
      },
      { name: "فاطمة شناوي", data: [69.7, 67.5, 68.5, 67, 66.2, 66, 65] },
      {
        name: "ليلى محاميد",
        data: [
          77.8,
          77.5,
          76.6,
          76.2,
          76,
          75.8,
          75.8,
          75.4,
          75,
          74.8,
          74,
          73.5,
          73,
          72
        ]
      },
      { name: "نداء ابو ريا", data: [88, 86, 85.5, 84.3, 84] },
      {
        name: "امنه= عبد الرحمان دقه",
        data: [80.5, 79, 78, 77.7, 77.5, 77, 76.8, 76.2]
      },
      { name: "هبة ابو مخ", data: [82.3] },
      {
        name: "رشا أبو شهوان",
        data: [74.9, 74.4, 74, 73.9, 73.2, 73, 73, 72.8]
      },
      { name: "ياسمين جمل", data: [76.8, 75.8, 75, 74, 74, 73] },
      {
        name: "أحمد أبو فرحة",
        data: [
          113,
          110.5,
          109.7,
          108,
          107.5,
          106.5,
          106.5,
          105.5,
          105.7,
          105.7,
          105
        ]
      },
      { name: "رابعة", data: [101, 100, 97, 97] },
      { name: "احلام زرازير", data: [86, 85, 83, 82] },
      { name: "مرفت عيسى احمد عوده", data: [87, 87.3, 86.5] },
      {
        name: "Marah Shattawi",
        data: [92, 91.3, 91, 90.2, 90, 89, 88.8, 88.7, 88, 87, 85.5, 84.6]
      },
      {
        name: "الاء قعدان",
        data: [72.4, 69.4, 68.3, 68, 67.5, 66, 66, 65, 65]
      },
      { name: "ميسون رجب امارة", data: [83, 82, 81, 80, 79, 78.9, 78.3, 78] },
      {
        name: "ثروت حماد",
        data: [96.3, 96, 94, 93.5, 93.2, 93, 92.8, 92, 90, 89.4, 89, 89, 88, 86]
      },
      {
        name: "نبيهه وتد",
        data: [
          64,
          63.5,
          63,
          62.5,
          62,
          62,
          61.3,
          61.8,
          61.6,
          61.2,
          61,
          60.7,
          61,
          59.1
        ]
      },
      {
        name: "رانيه مسعود",
        data: [72, 71.8, 71.5, 71, 70.6, 70, 70, 71, 72, 73, 72, 72, 71.9, 71]
      },
      { name: "نهيل خلف", data: [90, 89, 88.5, 88.2, 88] },
      {
        name: "raheeq ashkar",
        data: [80, 79.8, 79.5, 79.5, 78, 77, 77.5, 77, 77, 76.5, 76.3, 76]
      },
      { name: "جنان غانم", data: [93.3, 93, 92.5, 92, 91] },
      {
        name: "احلام مصطفى",
        data: [
          81.4,
          81.2,
          80.7,
          79.3,
          79.3,
          79,
          78.5,
          78,
          77.8,
          77,
          76.8,
          76,
          75.5
        ]
      },
      {
        name: "نيداء= محمود",
        data: [
          69.4,
          69,
          68.3,
          68,
          67.5,
          67,
          66,
          68,
          67.5,
          67,
          66.7,
          66,
          65.5,
          65
        ]
      }
    ],
    chartOptions: {
      legend: {
        show: false
      },
      chart: {
        height: 700,
        zoom: {
          enabled: false
        }
      },
      colors: themeColors,
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth",
        width: 0.4
      },

      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5
        }
      }
    }
  },

  lineChartSimpleCode: `<template>
  <vue-apex-charts type="line" height="350" :options="lineChartSimple.chartOptions" :series="lineChartSimple.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      lineChartSimple: {
        series: [{
          name: "Desktops",
          data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
        }],
        chartOptions: {
          chart: {
            height: 350,
            zoom: {
              enabled: false
            }
          },
          colors: themeColors,
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'straight'
          },
          title: {
            text: 'Product Trends by Month',
            align: 'left'
          },
          grid: {
            row: {
              colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
              opacity: 0.5
            },
          },
          xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
          }
        }
      }
    }
  }
  
</script>`,
  lineAreaChartSpline: {
    series: [
      {
        name: "Current Weight",
        data: [0, 6, 22, 28, 13, 6, 3, 0, 1, 0, 0, 0]
      },
      {
        name: "Initial Weight",
        data: [0, 5, 15, 25, 22, 4, 4, 3, 0, 1, 0, 1]
      }
    ],
    chartOptions: {
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "smooth"
      },
      colors: themeColors,
      xaxis: {
        categories: [50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160]
      }
    }
  },
  lineAreaChartSplineCode: `<template>
  <vue-apex-charts type="area" height="350" :options="lineAreaChartSpline.chartOptions" :series="lineAreaChartSpline.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      lineAreaChartSpline: {
        series: [{
            name: 'series1',
            data: [31, 40, 28, 51, 42, 109, 100]
          }, {
            name: 'series2',
            data: [11, 32, 45, 32, 34, 52, 41]
        }],
        chartOptions: {
          dataLabels: {
            enabled: false
          },
          stroke: {
            curve: 'smooth'
          },
          colors: themeColors,
          xaxis: {
            type: 'datetime',
            categories: ["2018-09-19T00:00:00", "2018-09-19T01:30:00", "2018-09-19T02:30:00",
              "2018-09-19T03:30:00", "2018-09-19T04:30:00", "2018-09-19T05:30:00",
              "2018-09-19T06:30:00"
            ],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          }
        }
      }
    }
  }
</script>`,
  columnChart: {
    series: [
      {
        name: "Water",
        data: [
          { x: "2/3/2020", y: 5 },
          { x: "2/4/2020", y: 5 },
          { x: "2/5/2020", y: 5 },
          { x: "2/6/2020", y: 0 },
          { x: "2/7/2020", y: 5 },
          { x: "2/8/2020", y: 0 },
          { x: "2/9/2020", y: 0 },
          { x: "2/10/2020", y: 10 },
          { x: "2/11/2020", y: 5 },
          { x: "2/12/2020", y: 0 },
          { x: "2/13/2020", y: 10 },
          { x: "2/14/2020", y: 5 },
          { x: "2/15/2020", y: 5 },
          { x: "2/16/2020", y: 5 },
          { x: "2/17/2020", y: 5 },
          { x: "2/18/2020", y: 5 },
          { x: "2/19/2020", y: 0 },
          { x: "2/20/2020", y: 5 },
          { x: "2/21/2020", y: 10 },
          { x: "2/22/2020", y: 5 },
          { x: "2/23/2020", y: 10 },
          { x: "2/24/2020", y: 5 },
          { x: "2/25/2020", y: 5 },
          { x: "2/26/2020", y: 5 },
          { x: "2/27/2020", y: 5 },
          { x: "2/28/2020", y: 5 },
          { x: "2/29/2020", y: 0 },
          { x: "3/1/2020", y: 0 },
          { x: "3/2/2020", y: 5 },
          { x: "3/3/2020", y: 10 },
          { x: "3/4/2020", y: 5 },
          { x: "3/5/2020", y: 0 },
          { x: "3/6/2020", y: 5 },
          { x: "3/7/2020", y: 5 },
          { x: "3/8/2020", y: 5 },
          { x: "3/9/2020", y: 10 },
          { x: "3/10/2020", y: 5 },
          { x: "3/11/2020", y: 0 },
          { x: "3/12/2020", y: 10 },
          { x: "3/13/2020", y: 10 },
          { x: "3/14/2020", y: 5 },
          { x: "3/15/2020", y: 5 },
          { x: "3/16/2020", y: 5 },
          { x: "3/17/2020", y: 5 },
          { x: "3/18/2020", y: 10 },
          { x: "3/19/2020", y: 5 },
          { x: "3/20/2020", y: 5 },
          { x: "3/21/2020", y: 0 },
          { x: "3/22/2020", y: 5 },
          { x: "3/23/2020", y: 5 },
          { x: "3/24/2020", y: 5 },
          { x: "3/25/2020", y: 5 },
          { x: "3/26/2020", y: 5 },
          { x: "3/27/2020", y: 5 },
          { x: "3/28/2020", y: 10 },
          { x: "3/29/2020", y: 0 },
          { x: "3/30/2020", y: 5 },
          { x: "3/31/2020", y: 5 },
          { x: "4/1/2020", y: 5 },
          { x: "4/2/2020", y: 5 },
          { x: "4/3/2020", y: 5 },
          { x: "4/4/2020", y: 5 },
          { x: "4/5/2020", y: 0 },
          { x: "4/6/2020", y: 5 }
        ]
      },
      {
        name: "Ordered Meals",
        data: [
          { x: "2/3/2020", y: 20 },
          { x: "2/4/2020", y: 10 },
          { x: "2/5/2020", y: 20 },
          { x: "2/6/2020", y: 0 },
          { x: "2/7/2020", y: 20 },
          { x: "2/8/2020", y: 0 },
          { x: "2/9/2020", y: 10 },
          { x: "2/10/2020", y: 20 },
          { x: "2/11/2020", y: 10 },
          { x: "2/12/2020", y: 0 },
          { x: "2/13/2020", y: 20 },
          { x: "2/14/2020", y: 20 },
          { x: "2/15/2020", y: 20 },
          { x: "2/16/2020", y: 20 },
          { x: "2/17/2020", y: 10 },
          { x: "2/18/2020", y: 20 },
          { x: "2/19/2020", y: 0 },
          { x: "2/20/2020", y: 20 },
          { x: "2/21/2020", y: 20 },
          { x: "2/22/2020", y: 20 },
          { x: "2/23/2020", y: 20 },
          { x: "2/24/2020", y: 10 },
          { x: "2/25/2020", y: 20 },
          { x: "2/26/2020", y: 20 },
          { x: "2/27/2020", y: 20 },
          { x: "2/28/2020", y: 20 },
          { x: "2/29/2020", y: 0 },
          { x: "3/1/2020", y: 0 },
          { x: "3/2/2020", y: 20 },
          { x: "3/3/2020", y: 20 },
          { x: "3/4/2020", y: 10 },
          { x: "3/5/2020", y: 0 },
          { x: "3/6/2020", y: 10 },
          { x: "3/7/2020", y: 20 },
          { x: "3/8/2020", y: 20 },
          { x: "3/9/2020", y: 20 },
          { x: "3/10/2020", y: 20 },
          { x: "3/11/2020", y: 0 },
          { x: "3/12/2020", y: 10 },
          { x: "3/13/2020", y: 10 },
          { x: "3/14/2020", y: 20 },
          { x: "3/15/2020", y: 10 },
          { x: "3/16/2020", y: 20 },
          { x: "3/17/2020", y: 20 },
          { x: "3/18/2020", y: 20 },
          { x: "3/19/2020", y: 20 },
          { x: "3/20/2020", y: 20 },
          { x: "3/21/2020", y: 0 },
          { x: "3/22/2020", y: 20 },
          { x: "3/23/2020", y: 20 },
          { x: "3/24/2020", y: 10 },
          { x: "3/25/2020", y: 20 },
          { x: "3/26/2020", y: 20 },
          { x: "3/27/2020", y: 20 },
          { x: "3/28/2020", y: 20 },
          { x: "3/29/2020", y: 0 },
          { x: "3/30/2020", y: 20 },
          { x: "3/31/2020", y: 20 },
          { x: "4/1/2020", y: 20 },
          { x: "4/2/2020", y: 10 },
          { x: "4/3/2020", y: 10 },
          { x: "4/4/2020", y: 10 },
          { x: "4/5/2020", y: 0 },
          { x: "4/6/2020", y: 20 }
        ]
      },
      {
        name: "Exercise",
        data: [
          { x: "2/3/2020", y: 38 },
          { x: "2/4/2020", y: 44 },
          { x: "2/5/2020", y: 38 },
          { x: "2/6/2020", y: 0 },
          { x: "2/7/2020", y: 33 },
          { x: "2/8/2020", y: 0 },
          { x: "2/9/2020", y: 0 },
          { x: "2/10/2020", y: 35 },
          { x: "2/11/2020", y: 35 },
          { x: "2/12/2020", y: 0 },
          { x: "2/13/2020", y: 35 },
          { x: "2/14/2020", y: 31 },
          { x: "2/15/2020", y: 31 },
          { x: "2/16/2020", y: 40 },
          { x: "2/17/2020", y: 34 },
          { x: "2/18/2020", y: 40 },
          { x: "2/19/2020", y: 0 },
          { x: "2/20/2020", y: 40 },
          { x: "2/21/2020", y: 34 },
          { x: "2/22/2020", y: 30 },
          { x: "2/23/2020", y: 36 },
          { x: "2/24/2020", y: 37 },
          { x: "2/25/2020", y: 32 },
          { x: "2/26/2020", y: 33 },
          { x: "2/27/2020", y: 31 },
          { x: "2/28/2020", y: 35 },
          { x: "2/29/2020", y: 0 },
          { x: "3/1/2020", y: 0 },
          { x: "3/2/2020", y: 35 },
          { x: "3/3/2020", y: 35 },
          { x: "3/4/2020", y: 35 },
          { x: "3/5/2020", y: 0 },
          { x: "3/6/2020", y: 34 },
          { x: "3/7/2020", y: 31 },
          { x: "3/8/2020", y: 38 },
          { x: "3/9/2020", y: 43 },
          { x: "3/10/2020", y: 38 },
          { x: "3/11/2020", y: 0 },
          { x: "3/12/2020", y: 35 },
          { x: "3/13/2020", y: 42 },
          { x: "3/14/2020", y: 42 },
          { x: "3/15/2020", y: 31 },
          { x: "3/16/2020", y: 38 },
          { x: "3/17/2020", y: 38 },
          { x: "3/18/2020", y: 35 },
          { x: "3/19/2020", y: 38 },
          { x: "3/20/2020", y: 35 },
          { x: "3/21/2020", y: 0 },
          { x: "3/22/2020", y: 36 },
          { x: "3/23/2020", y: 38 },
          { x: "3/24/2020", y: 38 },
          { x: "3/25/2020", y: 38 },
          { x: "3/26/2020", y: 39 },
          { x: "3/27/2020", y: 42 },
          { x: "3/28/2020", y: 37 },
          { x: "3/29/2020", y: 0 },
          { x: "3/30/2020", y: 39 },
          { x: "3/31/2020", y: 42 },
          { x: "4/1/2020", y: 38 },
          { x: "4/2/2020", y: 38 },
          { x: "4/3/2020", y: 31 },
          { x: "4/4/2020", y: 38 },
          { x: "4/5/2020", y: 0 },
          { x: "4/6/2020", y: 41 }
        ]
      },
      {
        name: "Dawsat Quata",
        data: [
          { x: "2/3/2020", y: 20 },
          { x: "2/4/2020", y: 20 },
          { x: "2/5/2020", y: 20 },
          { x: "2/6/2020", y: 20 },
          { x: "2/7/2020", y: 30 },
          { x: "2/8/2020", y: 20 },
          { x: "2/9/2020", y: 20 },
          { x: "2/10/2020", y: 20 },
          { x: "2/11/2020", y: 20 },
          { x: "2/12/2020", y: 0 },
          { x: "2/13/2020", y: 20 },
          { x: "2/14/2020", y: 20 },
          { x: "2/15/2020", y: 20 },
          { x: "2/16/2020", y: 10 },
          { x: "2/17/2020", y: 20 },
          { x: "2/18/2020", y: 20 },
          { x: "2/19/2020", y: 20 },
          { x: "2/20/2020", y: 20 },
          { x: "2/21/2020", y: 20 },
          { x: "2/22/2020", y: 20 },
          { x: "2/23/2020", y: 20 },
          { x: "2/24/2020", y: 20 },
          { x: "2/25/2020", y: 10 },
          { x: "2/26/2020", y: 20 },
          { x: "2/27/2020", y: 20 },
          { x: "2/28/2020", y: 20 },
          { x: "2/29/2020", y: 0 },
          { x: "3/1/2020", y: 0 },
          { x: "3/2/2020", y: 20 },
          { x: "3/3/2020", y: 20 },
          { x: "3/4/2020", y: 20 },
          { x: "3/5/2020", y: 20 },
          { x: "3/6/2020", y: 20 },
          { x: "3/7/2020", y: 10 },
          { x: "3/8/2020", y: 20 },
          { x: "3/9/2020", y: 20 },
          { x: "3/10/2020", y: 20 },
          { x: "3/11/2020", y: 20 },
          { x: "3/12/2020", y: 20 },
          { x: "3/13/2020", y: 20 },
          { x: "3/14/2020", y: 10 },
          { x: "3/15/2020", y: 20 },
          { x: "3/16/2020", y: 20 },
          { x: "3/17/2020", y: 20 },
          { x: "3/18/2020", y: 10 },
          { x: "3/19/2020", y: 20 },
          { x: "3/20/2020", y: 20 },
          { x: "3/21/2020", y: 0 },
          { x: "3/22/2020", y: 20 },
          { x: "3/23/2020", y: 20 },
          { x: "3/24/2020", y: 20 },
          { x: "3/25/2020", y: 20 },
          { x: "3/26/2020", y: 20 },
          { x: "3/27/2020", y: 20 },
          { x: "3/28/2020", y: 20 },
          { x: "3/29/2020", y: 0 },
          { x: "3/30/2020", y: 20 },
          { x: "3/31/2020", y: 20 },
          { x: "4/1/2020", y: 20 },
          { x: "4/2/2020", y: 20 },
          { x: "4/3/2020", y: 20 },
          { x: "4/4/2020", y: 20 },
          { x: "4/5/2020", y: 0 },
          { x: "4/6/2020", y: 20 }
        ]
      }
    ],
    chartOptions: {
      colors: themeColors,
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: "rounded",
          columnWidth: "100%"
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },

      xaxis: {
        type: "datetime",
        min: new Date("2/3/2020").getTime()
      },
      yaxis: {
        title: {
          text: "Score"
        }
      },
      fill: {
        opacity: 1
      }
    }
  },
  columnChartCode: `<template>
  <vue-apex-charts type="bar" height="350" :options="columnChart.chartOptions" :series="columnChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      columnChart: {
        series: [{
            name: 'Net Profit',
            data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
          }, {
            name: 'Revenue',
            data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
          }, {
            name: 'Free Cash Flow',
            data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
        }],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            bar: {
              horizontal: false,
              endingShape: 'rounded',
              columnWidth: '55%',
            },
          },
          dataLabels: {
            enabled: false
          },
          stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
          },

          xaxis: {
            categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
          },
          yaxis: {
            title: {
              text: '$ (thousands)'
            }
          },
          fill: {
            opacity: 1

          },
          tooltip: {
            y: {
              formatter: function(val) {
                return "$ " + val + " thousands"
              }
            }
          }
        }
      }
    }
  }
</script>`,
  barChart: {
    series: [
      {
        data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
      }
    ],
    chartOptions: {
      colors: themeColors,
      plotOptions: {
        bar: {
          horizontal: true
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: [
          "South Korea",
          "Canada",
          "United Kingdom",
          "Netherlands",
          "Italy",
          "France",
          "Japan",
          "United States",
          "China",
          "Germany"
        ]
      }
    }
  },
  barChartCode: `<template>
  <vue-apex-charts type="bar" height="350" :options="barChart.chartOptions" :series="barChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      barChart: {
        series: [{
            data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380]
        }],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            categories: ['South Korea', 'Canada', 'United Kingdom', 'Netherlands', 'Italy', 'France', 'Japan',
              'United States', 'China', 'Germany'
            ],
          }
        }
      }
    }
  }
</script>`,
  mixedChart: {
    series: [
      {
        name: "TEAM A",
        type: "column",
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
      },
      {
        name: "TEAM B",
        type: "area",
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
      },
      {
        name: "TEAM C",
        type: "line",
        data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
      }
    ],
    chartOptions: {
      colors: themeColors,
      chart: {
        stacked: false
      },
      stroke: {
        width: [0, 2, 5],
        curve: "smooth"
      },
      plotOptions: {
        bar: {
          columnWidth: "50%"
        }
      },

      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: "light",
          type: "vertical",
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100]
        }
      },
      labels: [
        "01/01/2003",
        "02/01/2003",
        "03/01/2003",
        "04/01/2003",
        "05/01/2003",
        "06/01/2003",
        "07/01/2003",
        "08/01/2003",
        "09/01/2003",
        "10/01/2003",
        "11/01/2003"
      ],
      markers: {
        size: 0
      },
      xaxis: {
        type: "datetime"
      },
      yaxis: {
        title: {
          text: "Points"
        },
        min: 0
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter(y) {
            if (typeof y !== "undefined") {
              return `${y.toFixed(0)} points`;
            }
            return y;
          }
        }
      }
    }
  },
  mixedChartCode: `<template>
  <vue-apex-charts type="line" height="350" :options="mixedChart.chartOptions" :series="mixedChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      mixedChart: {
        series: [{
            name: 'TEAM A',
            type: 'column',
            data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
          }, {
            name: 'TEAM B',
            type: 'area',
            data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
          }, {
            name: 'TEAM C',
            type: 'line',
            data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
        }],
        chartOptions: {
          colors: themeColors,
          chart: {
            stacked: false,
          },
          stroke: {
            width: [0, 2, 5],
            curve: 'smooth'
          },
          plotOptions: {
            bar: {
              columnWidth: '50%'
            }
          },

          fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
              inverseColors: false,
              shade: 'light',
              type: "vertical",
              opacityFrom: 0.85,
              opacityTo: 0.55,
              stops: [0, 100, 100, 100]
            }
          },
          labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
          markers: {
            size: 0
          },
          xaxis: {
            type: 'datetime'
          },
          yaxis: {
            title: {
              text: 'Points',
            },
            min: 0
          },
          tooltip: {
            shared: true,
            intersect: false,
            y: {
              formatter: function(y) {
                if (typeof y !== "undefined") {
                  return y.toFixed(0) + " points";
                }
                return y;

              }
            }
          }
        }
      }
    }
  }
</script>`,
  candlestickChart: {
    series: [
      {
        data: [
          {
            x: new Date(1538778600000),
            y: [6629.81, 6650.5, 6623.04, 6633.33]
          },
          {
            x: new Date(1538780400000),
            y: [6632.01, 6643.59, 6620, 6630.11]
          },
          {
            x: new Date(1538782200000),
            y: [6630.71, 6648.95, 6623.34, 6635.65]
          },
          {
            x: new Date(1538784000000),
            y: [6635.65, 6651, 6629.67, 6638.24]
          },
          {
            x: new Date(1538785800000),
            y: [6638.24, 6640, 6620, 6624.47]
          },
          {
            x: new Date(1538787600000),
            y: [6624.53, 6636.03, 6621.68, 6624.31]
          },
          {
            x: new Date(1538789400000),
            y: [6624.61, 6632.2, 6617, 6626.02]
          },
          {
            x: new Date(1538791200000),
            y: [6627, 6627.62, 6584.22, 6603.02]
          },
          {
            x: new Date(1538793000000),
            y: [6605, 6608.03, 6598.95, 6604.01]
          },
          {
            x: new Date(1538794800000),
            y: [6604.5, 6614.4, 6602.26, 6608.02]
          },
          {
            x: new Date(1538796600000),
            y: [6608.02, 6610.68, 6601.99, 6608.91]
          },
          {
            x: new Date(1538798400000),
            y: [6608.91, 6618.99, 6608.01, 6612]
          },
          {
            x: new Date(1538800200000),
            y: [6612, 6615.13, 6605.09, 6612]
          },
          {
            x: new Date(1538802000000),
            y: [6612, 6624.12, 6608.43, 6622.95]
          },
          {
            x: new Date(1538803800000),
            y: [6623.91, 6623.91, 6615, 6615.67]
          },
          {
            x: new Date(1538805600000),
            y: [6618.69, 6618.74, 6610, 6610.4]
          },
          {
            x: new Date(1538807400000),
            y: [6611, 6622.78, 6610.4, 6614.9]
          },
          {
            x: new Date(1538809200000),
            y: [6614.9, 6626.2, 6613.33, 6623.45]
          },
          {
            x: new Date(1538811000000),
            y: [6623.48, 6627, 6618.38, 6620.35]
          },
          {
            x: new Date(1538812800000),
            y: [6619.43, 6620.35, 6610.05, 6615.53]
          },
          {
            x: new Date(1538814600000),
            y: [6615.53, 6617.93, 6610, 6615.19]
          },
          {
            x: new Date(1538816400000),
            y: [6615.19, 6621.6, 6608.2, 6620]
          },
          {
            x: new Date(1538818200000),
            y: [6619.54, 6625.17, 6614.15, 6620]
          },
          {
            x: new Date(1538820000000),
            y: [6620.33, 6634.15, 6617.24, 6624.61]
          },
          {
            x: new Date(1538821800000),
            y: [6625.95, 6626, 6611.66, 6617.58]
          },
          {
            x: new Date(1538823600000),
            y: [6619, 6625.97, 6595.27, 6598.86]
          },
          {
            x: new Date(1538825400000),
            y: [6598.86, 6598.88, 6570, 6587.16]
          },
          {
            x: new Date(1538827200000),
            y: [6588.86, 6600, 6580, 6593.4]
          },
          {
            x: new Date(1538829000000),
            y: [6593.99, 6598.89, 6585, 6587.81]
          },
          {
            x: new Date(1538830800000),
            y: [6587.81, 6592.73, 6567.14, 6578]
          },
          {
            x: new Date(1538832600000),
            y: [6578.35, 6581.72, 6567.39, 6579]
          },
          {
            x: new Date(1538834400000),
            y: [6579.38, 6580.92, 6566.77, 6575.96]
          },
          {
            x: new Date(1538836200000),
            y: [6575.96, 6589, 6571.77, 6588.92]
          },
          {
            x: new Date(1538838000000),
            y: [6588.92, 6594, 6577.55, 6589.22]
          },
          {
            x: new Date(1538839800000),
            y: [6589.3, 6598.89, 6589.1, 6596.08]
          },
          {
            x: new Date(1538841600000),
            y: [6597.5, 6600, 6588.39, 6596.25]
          },
          {
            x: new Date(1538843400000),
            y: [6598.03, 6600, 6588.73, 6595.97]
          },
          {
            x: new Date(1538845200000),
            y: [6595.97, 6602.01, 6588.17, 6602]
          },
          {
            x: new Date(1538847000000),
            y: [6602, 6607, 6596.51, 6599.95]
          },
          {
            x: new Date(1538848800000),
            y: [6600.63, 6601.21, 6590.39, 6591.02]
          },
          {
            x: new Date(1538850600000),
            y: [6591.02, 6603.08, 6591, 6591]
          },
          {
            x: new Date(1538852400000),
            y: [6591, 6601.32, 6585, 6592]
          },
          {
            x: new Date(1538854200000),
            y: [6593.13, 6596.01, 6590, 6593.34]
          },
          {
            x: new Date(1538856000000),
            y: [6593.34, 6604.76, 6582.63, 6593.86]
          },
          {
            x: new Date(1538857800000),
            y: [6593.86, 6604.28, 6586.57, 6600.01]
          },
          {
            x: new Date(1538859600000),
            y: [6601.81, 6603.21, 6592.78, 6596.25]
          },
          {
            x: new Date(1538861400000),
            y: [6596.25, 6604.2, 6590, 6602.99]
          },
          {
            x: new Date(1538863200000),
            y: [6602.99, 6606, 6584.99, 6587.81]
          },
          {
            x: new Date(1538865000000),
            y: [6587.81, 6595, 6583.27, 6591.96]
          },
          {
            x: new Date(1538866800000),
            y: [6591.97, 6596.07, 6585, 6588.39]
          },
          {
            x: new Date(1538868600000),
            y: [6587.6, 6598.21, 6587.6, 6594.27]
          },
          {
            x: new Date(1538870400000),
            y: [6596.44, 6601, 6590, 6596.55]
          },
          {
            x: new Date(1538872200000),
            y: [6598.91, 6605, 6596.61, 6600.02]
          },
          {
            x: new Date(1538874000000),
            y: [6600.55, 6605, 6589.14, 6593.01]
          },
          {
            x: new Date(1538875800000),
            y: [6593.15, 6605, 6592, 6603.06]
          },
          {
            x: new Date(1538877600000),
            y: [6603.07, 6604.5, 6599.09, 6603.89]
          },
          {
            x: new Date(1538879400000),
            y: [6604.44, 6604.44, 6600, 6603.5]
          },
          {
            x: new Date(1538881200000),
            y: [6603.5, 6603.99, 6597.5, 6603.86]
          },
          {
            x: new Date(1538883000000),
            y: [6603.85, 6605, 6600, 6604.07]
          },
          {
            x: new Date(1538884800000),
            y: [6604.98, 6606, 6604.07, 6606]
          }
        ]
      }
    ],
    chartOptions: {
      colors: themeColors,
      xaxis: {
        type: "datetime"
      },
      yaxis: {
        tooltip: {
          enabled: true
        }
      }
    }
  },
  candlestickChartCode: `<template>
  <vue-apex-charts type="candlestick" height="350" :options="candlestickChart.chartOptions" :series="candlestickChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      candlestickChart: {
        series: [{
          data: [{ x: new Date(1538778600000), y: [6629.81, 6650.5, 6623.04, 6633.33] },
            { x: new Date(1538780400000), y: [6632.01, 6643.59, 6620, 6630.11] },
            { x: new Date(1538782200000), y: [6630.71, 6648.95, 6623.34, 6635.65] },
            { x: new Date(1538784000000), y: [6635.65, 6651, 6629.67, 6638.24] },
            { x: new Date(1538785800000), y: [6638.24, 6640, 6620, 6624.47] },
            { x: new Date(1538787600000), y: [6624.53, 6636.03, 6621.68, 6624.31] },
            { x: new Date(1538789400000), y: [6624.61, 6632.2, 6617, 6626.02] },
            { x: new Date(1538791200000), y: [6627, 6627.62, 6584.22, 6603.02] },
            { x: new Date(1538793000000), y: [6605, 6608.03, 6598.95, 6604.01] },
            { x: new Date(1538794800000), y: [6604.5, 6614.4, 6602.26, 6608.02] },
            { x: new Date(1538796600000), y: [6608.02, 6610.68, 6601.99, 6608.91] },
            { x: new Date(1538798400000), y: [6608.91, 6618.99, 6608.01, 6612] },
            { x: new Date(1538800200000), y: [6612, 6615.13, 6605.09, 6612] },
            { x: new Date(1538802000000), y: [6612, 6624.12, 6608.43, 6622.95] },
            { x: new Date(1538803800000), y: [6623.91, 6623.91, 6615, 6615.67] },
            { x: new Date(1538805600000), y: [6618.69, 6618.74, 6610, 6610.4] },
            { x: new Date(1538807400000), y: [6611, 6622.78, 6610.4, 6614.9] },
            { x: new Date(1538809200000), y: [6614.9, 6626.2, 6613.33, 6623.45] },
            { x: new Date(1538811000000), y: [6623.48, 6627, 6618.38, 6620.35] },
            { x: new Date(1538812800000), y: [6619.43, 6620.35, 6610.05, 6615.53] },
            { x: new Date(1538814600000), y: [6615.53, 6617.93, 6610, 6615.19] },
            { x: new Date(1538816400000), y: [6615.19, 6621.6, 6608.2, 6620] },
            { x: new Date(1538818200000), y: [6619.54, 6625.17, 6614.15, 6620] },
            { x: new Date(1538820000000), y: [6620.33, 6634.15, 6617.24, 6624.61] },
            { x: new Date(1538821800000), y: [6625.95, 6626, 6611.66, 6617.58] },
            { x: new Date(1538823600000), y: [6619, 6625.97, 6595.27, 6598.86] },
            { x: new Date(1538825400000), y: [6598.86, 6598.88, 6570, 6587.16] },
            { x: new Date(1538827200000), y: [6588.86, 6600, 6580, 6593.4] },
            { x: new Date(1538829000000), y: [6593.99, 6598.89, 6585, 6587.81] },
            { x: new Date(1538830800000), y: [6587.81, 6592.73, 6567.14, 6578] },
            { x: new Date(1538832600000), y: [6578.35, 6581.72, 6567.39, 6579] },
            { x: new Date(1538834400000), y: [6579.38, 6580.92, 6566.77, 6575.96] },
            { x: new Date(1538836200000), y: [6575.96, 6589, 6571.77, 6588.92] },
            { x: new Date(1538838000000), y: [6588.92, 6594, 6577.55, 6589.22] },
            { x: new Date(1538839800000), y: [6589.3, 6598.89, 6589.1, 6596.08] },
            { x: new Date(1538841600000), y: [6597.5, 6600, 6588.39, 6596.25] },
            { x: new Date(1538843400000), y: [6598.03, 6600, 6588.73, 6595.97] },
            { x: new Date(1538845200000), y: [6595.97, 6602.01, 6588.17, 6602] },
            { x: new Date(1538847000000), y: [6602, 6607, 6596.51, 6599.95] },
            { x: new Date(1538848800000), y: [6600.63, 6601.21, 6590.39, 6591.02] },
            { x: new Date(1538850600000), y: [6591.02, 6603.08, 6591, 6591] },
            { x: new Date(1538852400000), y: [6591, 6601.32, 6585, 6592] },
            { x: new Date(1538854200000), y: [6593.13, 6596.01, 6590, 6593.34] },
            { x: new Date(1538856000000), y: [6593.34, 6604.76, 6582.63, 6593.86] },
            { x: new Date(1538857800000), y: [6593.86, 6604.28, 6586.57, 6600.01] },
            { x: new Date(1538859600000), y: [6601.81, 6603.21, 6592.78, 6596.25] },
            { x: new Date(1538861400000), y: [6596.25, 6604.2, 6590, 6602.99] },
            { x: new Date(1538863200000), y: [6602.99, 6606, 6584.99, 6587.81] },
            { x: new Date(1538865000000), y: [6587.81, 6595, 6583.27, 6591.96] },
            { x: new Date(1538866800000), y: [6591.97, 6596.07, 6585, 6588.39] },
            { x: new Date(1538868600000), y: [6587.6, 6598.21, 6587.6, 6594.27] },
            { x: new Date(1538870400000), y: [6596.44, 6601, 6590, 6596.55] },
            { x: new Date(1538872200000), y: [6598.91, 6605, 6596.61, 6600.02] },
            { x: new Date(1538874000000), y: [6600.55, 6605, 6589.14, 6593.01] },
            { x: new Date(1538875800000), y: [6593.15, 6605, 6592, 6603.06] },
            { x: new Date(1538877600000), y: [6603.07, 6604.5, 6599.09, 6603.89] },
            { x: new Date(1538879400000), y: [6604.44, 6604.44, 6600, 6603.5] },
            { x: new Date(1538881200000), y: [6603.5, 6603.99, 6597.5, 6603.86] },
            { x: new Date(1538883000000), y: [6603.85, 6605, 6600, 6604.07] },
            { x: new Date(1538884800000), y: [6604.98, 6606, 6604.07, 6606] },
          ]
        }],
        chartOptions: {
          colors: themeColors,
          xaxis: {
            type: 'datetime'
          },
          yaxis: {
            tooltip: {
              enabled: true
            }
          }
        }
      }
    }
  }
</script>`,
  bubbleChart: {
    series: [
      {
        name: "Product1",
        data: generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
          min: 10,
          max: 60
        })
      },
      {
        name: "Product2",
        data: generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
          min: 10,
          max: 60
        })
      },
      {
        name: "Product3",
        data: generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
          min: 10,
          max: 60
        })
      },
      {
        name: "Product4",
        data: generateData(new Date("11 Feb 2017 GMT").getTime(), 20, {
          min: 10,
          max: 60
        })
      }
    ],
    chartOptions: {
      colors: themeColors,
      dataLabels: {
        enabled: false
      },
      fill: {
        type: "gradient"
      },
      xaxis: {
        tickAmount: 12,
        type: "datetime",

        labels: {
          rotate: 0
        }
      },
      yaxis: {
        max: 70
      },
      theme: {
        palette: "palette2"
      }
    }
  },
  bubbleChartCode: `<template>
  <vue-apex-charts type="bubble" height="350" :options="bubbleChart.chartOptions" :series="bubbleChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      bubbleChart: {
        series: [{
            name: 'Product1',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          },
          {
            name: 'Product2',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          },
          {
            name: 'Product3',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          },
          {
            name: 'Product4',
            data: generateData(new Date('11 Feb 2017 GMT').getTime(), 20, {
              min: 10,
              max: 60
            })
          }
        ],
        chartOptions: {
          colors: themeColors,
          dataLabels: {
            enabled: false
          },
          fill: {
            type: 'gradient',
          },
          xaxis: {
            tickAmount: 12,
            type: 'datetime',

            labels: {
              rotate: 0,
            }
          },
          yaxis: {
            max: 70
          },
          theme: {
            palette: 'palette2'
          }
        }
      }
    }
  }
</script>`,
  scatterChart: {
    series: [
      {
        name: "Initial Weight",
        data: [
          [16.4, 5.4],
          [21.7, 2],
          [25.4, 3],
          [19, 2],
          [10.9, 1],
          [13.6, 3.2],
          [10.9, 7.4],
          [10.9, 0],
          [10.9, 8.2],
          [16.4, 0],
          [16.4, 1.8],
          [13.6, 0.3],
          [13.6, 0],
          [29.9, 0],
          [27.1, 2.3],
          [16.4, 0],
          [13.6, 3.7],
          [10.9, 5.2],
          [16.4, 6.5],
          [10.9, 0],
          [24.5, 7.1],
          [10.9, 0],
          [8.1, 4.7],
          [19, 0],
          [21.7, 1.8],
          [27.1, 0],
          [24.5, 0],
          [27.1, 0],
          [29.9, 1.5],
          [27.1, 0.8],
          [22.1, 2]
        ]
      },
      {
        name: "SAMPLE B",
        data: [
          [6.4, 13.4],
          [1.7, 11],
          [5.4, 8],
          [9, 17],
          [1.9, 4],
          [3.6, 12.2],
          [1.9, 14.4],
          [1.9, 9],
          [1.9, 13.2],
          [1.4, 7],
          [6.4, 8.8],
          [3.6, 4.3],
          [1.6, 10],
          [9.9, 2],
          [7.1, 15],
          [1.4, 0],
          [3.6, 13.7],
          [1.9, 15.2],
          [6.4, 16.5],
          [0.9, 10],
          [4.5, 17.1],
          [10.9, 10],
          [0.1, 14.7],
          [9, 10],
          [12.7, 11.8],
          [2.1, 10],
          [2.5, 10],
          [27.1, 10],
          [2.9, 11.5],
          [7.1, 10.8],
          [2.1, 12]
        ]
      },
      {
        name: "SAMPLE C",
        data: [
          [21.7, 3],
          [23.6, 3.5],
          [24.6, 3],
          [29.9, 3],
          [21.7, 20],
          [23, 2],
          [10.9, 3],
          [28, 4],
          [27.1, 0.3],
          [16.4, 4],
          [13.6, 0],
          [19, 5],
          [22.4, 3],
          [24.5, 3],
          [32.6, 3],
          [27.1, 4],
          [29.6, 6],
          [31.6, 8],
          [21.6, 5],
          [20.9, 4],
          [22.4, 0],
          [32.6, 10.3],
          [29.7, 20.8],
          [24.5, 0.8],
          [21.4, 0],
          [21.7, 6.9],
          [28.6, 7.7],
          [15.4, 0],
          [18.1, 0],
          [33.4, 0],
          [16.4, 0]
        ]
      }
    ],
    chartOptions: {
      colors: themeColors,
      chart: {
        zoom: {
          enabled: true,
          type: "xy"
        }
      },
      xaxis: {
        tickAmount: 10
      },
      yaxis: {
        tickAmount: 7
      }
    }
  },
  scatterChartCode: `<template>
  <vue-apex-charts type="scatter" height="350" :options="scatterChart.chartOptions" :series="scatterChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      scatterChart: {
        series: [{
          name: "SAMPLE A",
          data: [
            [16.4, 5.4],
            [21.7, 2],
            [25.4, 3],
            [19, 2],
            [10.9, 1],
            [13.6, 3.2],
            [10.9, 7.4],
            [10.9, 0],
            [10.9, 8.2],
            [16.4, 0],
            [16.4, 1.8],
            [13.6, 0.3],
            [13.6, 0],
            [29.9, 0],
            [27.1, 2.3],
            [16.4, 0],
            [13.6, 3.7],
            [10.9, 5.2],
            [16.4, 6.5],
            [10.9, 0],
            [24.5, 7.1],
            [10.9, 0],
            [8.1, 4.7],
            [19, 0],
            [21.7, 1.8],
            [27.1, 0],
            [24.5, 0],
            [27.1, 0],
            [29.9, 1.5],
            [27.1, 0.8],
            [22.1, 2]
          ]
        }, {
          name: "SAMPLE B",
          data: [
            [6.4, 13.4],
            [1.7, 11],
            [5.4, 8],
            [9, 17],
            [1.9, 4],
            [3.6, 12.2],
            [1.9, 14.4],
            [1.9, 9],
            [1.9, 13.2],
            [1.4, 7],
            [6.4, 8.8],
            [3.6, 4.3],
            [1.6, 10],
            [9.9, 2],
            [7.1, 15],
            [1.4, 0],
            [3.6, 13.7],
            [1.9, 15.2],
            [6.4, 16.5],
            [0.9, 10],
            [4.5, 17.1],
            [10.9, 10],
            [0.1, 14.7],
            [9, 10],
            [12.7, 11.8],
            [2.1, 10],
            [2.5, 10],
            [27.1, 10],
            [2.9, 11.5],
            [7.1, 10.8],
            [2.1, 12]
          ]
        }, {
          name: "SAMPLE C",
          data: [
            [21.7, 3],
            [23.6, 3.5],
            [24.6, 3],
            [29.9, 3],
            [21.7, 20],
            [23, 2],
            [10.9, 3],
            [28, 4],
            [27.1, 0.3],
            [16.4, 4],
            [13.6, 0],
            [19, 5],
            [22.4, 3],
            [24.5, 3],
            [32.6, 3],
            [27.1, 4],
            [29.6, 6],
            [31.6, 8],
            [21.6, 5],
            [20.9, 4],
            [22.4, 0],
            [32.6, 10.3],
            [29.7, 20.8],
            [24.5, 0.8],
            [21.4, 0],
            [21.7, 6.9],
            [28.6, 7.7],
            [15.4, 0],
            [18.1, 0],
            [33.4, 0],
            [16.4, 0]
          ]
        }],
        chartOptions: {
          colors: themeColors,
          chart: {
            zoom: {
              enabled: true,
              type: 'xy'
            }
          },
          xaxis: {
            tickAmount: 10,
          },
          yaxis: {
            tickAmount: 7
          }
        }
      }
    }
  }
</script>`,
  heatMapChart: {
    series: [
      {
        name: "Metric1",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric2",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric3",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric4",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric5",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric6",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric7",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric8",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      },
      {
        name: "Metric9",
        data: generateDataHeatMap(18, {
          min: 0,
          max: 90
        })
      }
    ],
    chartOptions: {
      dataLabels: {
        enabled: false
      },
      colors: ["#7367F0"]
    }
  },
  heatMapChartCode: `<template>
  <vue-apex-charts type="heatmap" height="350" :options="heatMapChart.chartOptions" :series="heatMapChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      heatMapChart: {
        series: [{
            name: 'Metric1',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric2',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric3',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric4',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric5',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric6',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric7',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric8',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          },
          {
            name: 'Metric9',
            data: generateDataHeatMap(18, {
              min: 0,
              max: 90
            })
          }
          ],
        chartOptions: {
          colors: themeColors,
          dataLabels: {
            enabled: false
          },
          colors: ["#008FFB"],
        }
      }
    }
  }
</script>`,
  pieChart: {
    series: [44, 55, 13, 43],
    chartOptions: {
      labels: ["Team A", "Team B", "Team C", "Team D"],
      colors: themeColors,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    }
  },
  pieChartCode: `<template>
  <vue-apex-charts type="pie" height="350" :options="pieChart.chartOptions" :series="pieChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      pieChart: {
        series: [44, 55, 13, 43],
        chartOptions: {
          labels: ['Team A', 'Team B', 'Team C', 'Team D'],
          colors: themeColors,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
      }
    }
  }
</script>`,
  donutChart: {
    series: [44, 55, 41, 17],
    chartOptions: {
      colors: themeColors,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    }
  },
  donutChartCode: `<template>
  <vue-apex-charts type="donut" height="350" :options="donutChart.chartOptions" :series="donutChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      donutChart: {
        series: [44, 55, 41, 17],
        chartOptions: {
          colors: themeColors,
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        }
      }
    }
  }
</script>`,
  radialBarChart: {
    series: [44, 55, 67, 83],
    chartOptions: {
      colors: themeColors,
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px"
            },
            value: {
              fontSize: "16px"
            },
            total: {
              show: true,
              label: "Total",
              formatter() {
                // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                return 249;
              }
            }
          }
        }
      },
      labels: ["Apples", "Oranges", "Bananas", "Berries"]
    }
  },
  radialBarChartCode: `<template>
  <vue-apex-charts type="radialBar" height="350" :options="radialBarChart.chartOptions" :series="radialBarChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      radialBarChart: {
        series: [44, 55, 67, 83],
        chartOptions: {
          colors: themeColors,
          plotOptions: {
            radialBar: {
              dataLabels: {
                name: {
                  fontSize: '22px',
                },
                value: {
                  fontSize: '16px',
                },
                total: {
                  show: true,
                  label: 'Total',
                  formatter: function(w) {
                    // By default this function returns the average of all series. The below is just an example to show the use of custom formatter function
                    return 249
                  }
                }
              }
            }
          },
          labels: ['Apples', 'Oranges', 'Bananas', 'Berries'],
        }
      }
    }
  }
</script>`,
  radarChart: {
    series: [
      {
        name: "Series 1",
        data: [80, 50, 30, 40, 100, 20]
      }
    ],
    chartOptions: {
      colors: themeColors,
      labels: ["January", "February", "March", "April", "May", "June"]
    }
  },
  radarChartCode: `<template>
  <vue-apex-charts type="radar" height="350" :options="radarChart.chartOptions" :series="radarChart.series"></vue-apex-charts>
</template>

<script>
  data() {
    return {
      themeColors: ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      radarChart: {
        series: [{
          name: 'Series 1',
          data: [80, 50, 30, 40, 100, 20],
        }],
        chartOptions: {
          colors: themeColors,
          labels: ['January', 'February', 'March', 'April', 'May', 'June'],
        }
      }
    }
  }
</script>`
};
